import PayOnDelivery from "../components/checkout/PayOnDelivery";

    const PayOnDeliveryPage = () => {
        return ( 
            <div>
                <PayOnDelivery />
            </div>
         );
    }
     
    export default PayOnDeliveryPage;